import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL

export function getRequestCTXID(id:any) {
    return axios.get(API_URL+'/v1/newctx/'+id)
  }